export const APP_STORE_URL =
  process.env.NEXT_PUBLIC_APP_STORE_URL ||
  'https://apps.apple.com/ca/app/good-neighbor-days/id6736345224';
export const PLAY_STORE_URL = process.env.NEXT_PUBLIC_PLAY_STORE_URL || '';
export const BANNER_DISMISSED_KEY = 'gn_promo_banner_dismissed';
export const SHOW_DOWNLOAD_APP_BANNER =
  process.env.NEXT_PUBLIC_SHOW_DOWNLOAD_APP_BANNER === 'true';
